export const SHIPPER = 'shipper';
export const CARRIER = 'carrier';
export const CONSIGNEE = 'consignee';
export const VENDOR = 'vendor';
export const PARTNER = 'partner';
export const WAREHOUSE = 'Warehouse';
const USER_TYPES = {
    SHIPPER,
    CARRIER,
    CONSIGNEE,
    VENDOR,
    PARTNER,
    WAREHOUSE,
};
export default USER_TYPES;
